import {
	useChangeCommentTextForRubberTechMapMutation,
	useCreateCommentForRubberTechMapMutation,
	useDeleteCommentForRubberTechMapMutation,
	useGetRubberTechMapCommentsQuery,
} from '@/shared/state/api/swagger';
import { FC } from 'react';
import { TechCardCommentsModal } from './tech-card-comments-modal';
import { TechMapRubberCommentModalProps } from './tech-card-comments-modal.types';

export const TechCardRubberCommentModal: FC<TechMapRubberCommentModalProps> = ({ techMapId, ...modalProps }) => {
	const { data: comments, isFetching: commentsFetching } = useGetRubberTechMapCommentsQuery(
		{ rubberTechMapId: techMapId },
		{
			selectFromResult: (result) => ({
				...result,
				data: result?.data?.map((item) => ({ ...item, techMapId: item.rubber_tech_map_id })) || [],
			}),
		},
	);
	const [deleteComment, { isLoading: deleteCommentLoading }] = useDeleteCommentForRubberTechMapMutation();
	const [changeComment, { isLoading: changeCommentLoading }] = useChangeCommentTextForRubberTechMapMutation();
	const [createComment, { isLoading: createCommentLoading }] = useCreateCommentForRubberTechMapMutation();
	const onCreateComment = (text: string) =>
		createComment({ rubberTechMapId: techMapId, rubberTechMapCommentCreateRequest: { text } }).unwrap();
	const onDeleteComment = ({ commentId, techMapId }: { commentId: number; techMapId: number }) =>
		deleteComment({ rubberTechMapId: techMapId, rubberCommentId: commentId }).unwrap();
	const onChangeComment = ({ commentId, techMapId, text }: { commentId: number; techMapId: number; text: string }) =>
		changeComment({
			rubberTechMapId: techMapId,
			rubberCommentId: commentId,
			rubberTechMapCommentUpdateTextRequest: { text },
		}).unwrap();

	return (
		<TechCardCommentsModal
			data={comments}
			isCommentsLoading={commentsFetching}
			isCreateCommentLoading={createCommentLoading}
			onCreateComment={onCreateComment}
			onDeleteComment={onDeleteComment}
			onChangeComment={onChangeComment}
			isChangeCommentLoading={changeCommentLoading}
			isDeleteCommentLoading={deleteCommentLoading}
			techMapId={techMapId}
			{...modalProps}
		/>
	);
};
